module.exports = __webpack_public_path__ + "static/media/Warmup.002617ca.jpg";